export default {
  // keep this environment-config if you want to use ?debug=1
  debug: {
    logging: {
      log: true,
      debug: true,
      info: true,
      warn: true,
      error: true,
      target: 'console',
    },
  },

  // default environment config—leave this as is
  default: {
    hostname: '',
    logging: {
      log: true,
      debug: false,
      info: false,
      warn: false,
      error: false,
      target: 'noop',
    },
    analytics: {
      trackers: [],
    },
  },

  // default config for demo-environment
  demo: {
    hostname: 'ktag.ag.ch',
    logging: {
      log: true,
      target: 'console',
    },
    analytics: {
      trackers: [
        {
          name: 'styleguide-ga4',
          trackerId: 'G-TV5QXFNER1',
        },
      ],
    },
  },

  // you can define as many environment-configs as you want...
  development: {
    hostname: 'localhost',
    logging: {
      log: true,
      debug: true,
      info: true,
      warn: true,
      error: true,
      target: 'console',
    },
    analytics: {
      // those are just for testing purposes
      trackers: [
        {
          name: 'styleguide-ga4',
          trackerId: 'G-XXXXXXXXXX',
        },
        {
          name: 'devMatomo',
          trackerId: '1',
          // set type and provide the full URL to the piwik.js-script on your server
          type: 'matomo',
          // no url: no matomo tracker will be activated. if you want to use one,
          // provide the full url to piwik.js, sth. like: https://domain.com/piwik.js
          url: '',
        },
      ],
    },
  },
};
